import { NavigationType, useNavigationType } from "react-router-dom";

let hasTraversedHistory = false;

// Called by the app's popstate listener before React Router handles the event.
// Initial router POPs are fresh entries, not Back/Forward navigation.
export function recordHistoryTraversal(): void {
  hasTraversedHistory = true;
}

export function useIsHistoryTraversal(): boolean {
  return useNavigationType() === NavigationType.Pop && hasTraversedHistory;
}
